export const quickPromptContent = [
  {
    id: 0,
    contentList: [
      {
        contentType: "text",
        content: "I am seeking a comprehensive analysis on the licensing potential of",
      },
      {
        contentType: "prompt",
        keyword: "wearable-sensor",
        placeholder: "Wearable sensor",
      },
      {
        contentType: "text",
        content: "in the",
      },
      {
        contentType: "prompt",
        keyword: "industry-or-market",
        placeholder: "[Industry/Market]",
      },
      {
        contentType: "text",
        content: "for",
      },
      {
        contentType: "prompt",
        keyword: "purpose-or-objective",
        placeholder: "[Purpose/Objective]",
      },
      {
        contentType: "text",
        content: ". I am particularly interested in",
      },
      {
        contentType: "prompt",
        keyword: "specifi-aspect",
        placeholder: "[specific aspect, e.g., major players, market trends, geographical focus]",
      },
      {
        contentType: "text",
        content: "and need detailed insights on ",
      },
      {
        contentType: "prompt",
        keyword: "specific-detail",
        placeholder:
          "[specific detail, e.g., potential partners, market entry barriers, pricing strategies]",
      },
      {
        contentType: "text",
        content: ". This analysis will help",
      },
      {
        contentType: "prompt",
        keyword: "specific-goal",
        placeholder:
          "[specific goal or decision, e.g., inform our strategy, guide our negotiations]",
      },
      {
        contentType: "text",
        content: ".",
      },
    ],
  },
];
